import React from 'react';
import { useTranslation } from 'react-i18next';
import './styles.scss';

const PasswordComplexityNotice = () => {
  const { t } = useTranslation();

  return (
    <div className="PasswordComplexityNotice">
      <div className="PasswordComplexityNotice__title">
        {t('Password must contain:')}
      </div>
      <ul className="PasswordComplexityNotice__list">
        <li>{t('At least 12 characters')}</li>
        <li>{t('At least one lowercase letter (a-z)')}</li>
        <li>{t('At least one uppercase letter (A-Z)')}</li>
        <li>{t('At least one digit (0-9)')}</li>
        <li>{t('At least one special character (!@#^&*)')}</li>
      </ul>
    </div>
  );
};

export default PasswordComplexityNotice;
